<div class="flx-modal" role="dialog" aria-modal="true">
    <!-- header -->
   <div class="flx-modal__header w-f3">
        <div class="with-desc">
            <h2>Grouping Options</h2>
            <div class="sub">Refine your schedule</div>
        </div>

        <button class="icon-btn" [pTooltip]="translate?.general.buttons.close.singular" (click)="modalRef.hide()">
            <i class="fa-regular fa-xmark"></i>
        </button>
    </div>
    <form>
        <div class="flx-modal__body mp-body">
            <label class="field-label">Group By</label>

            <div class="field-row field-row--auto mb-2">
                <div>
                    <p-dropdown [placeholder]="'Select Grouping'" [options]="groupByOptions" optionLabel="label" [(ngModel)]="selectedGroupBy" name="groupBy"></p-dropdown>
                </div>
            </div>
        </div>
    </form>
    <!-- footer -->
    <div class="flx-modal__footer">
        <button type="button" class="custella-btn-white" (click)="modalRef.hide()">{{translate?.general.buttons.cancel.singular}}</button>
        <!-- <p-button type="button" [label]="translate?.general.buttons.clear.singular" styleClass="h-32 dark" (onClick)="onClear()"></p-button> -->
        <p-button type="button" icon="fa-regular fa-check" [label]="translate?.general.buttons.confirm.singular" styleClass="h-32" (onClick)="onConfirm()"></p-button>
    </div>
</div>